export enum CancelMeetingPageState {
    ConfirmSendRequest,
    RequestSent,
}
